import { CRUDPathSegmentEn } from '@martech-solution/utils/constants';

const purchasePath = {
  purchase: '/erp/purchase',

  // PR - Yêu cầu mua hàng
  pr: '/erp/purchase/pr',
  prDetail: '/erp/purchase/pr' + CRUDPathSegmentEn.DETAIL,
  prAdd: '/erp/purchase/pr' + CRUDPathSegmentEn.ADD,
  prEdit: '/erp/purchase/pr' + CRUDPathSegmentEn.EDIT,

  // PQR - Yêu cầu báo giá mua hàng
  purchaseQuotationRequest: '/erp/purchase/purchase-quotation-request',
  purchaseQuotationRequestDetail: '/erp/purchase/purchase-quotation-request' + CRUDPathSegmentEn.DETAIL,
  purchaseQuotationRequestAdd: '/erp/purchase/purchase-quotation-request' + CRUDPathSegmentEn.ADD,
  purchaseQuotationRequestEdit: '/erp/purchase/purchase-quotation-request' + CRUDPathSegmentEn.EDIT,

  // PQ - Báo giá mua hàng
  purchaseQuotation: '/erp/purchase/purchase-quotation',
  purchaseQuotationDetail: '/erp/purchase/purchase-quotation' + CRUDPathSegmentEn.DETAIL,
  purchaseQuotationAdd: '/erp/purchase/purchase-quotation' + CRUDPathSegmentEn.ADD,
  purchaseQuotationEdit: '/erp/purchase/purchase-quotation' + CRUDPathSegmentEn.EDIT,

  // PO - Đơn đặt mua hàng
  purchaseOrder: '/erp/purchase/purchase-order',
  purchaseOrderDetail: '/erp/purchase/purchase-order' + CRUDPathSegmentEn.DETAIL,
  purchaseOrderAdd: '/erp/purchase/purchase-order' + CRUDPathSegmentEn.ADD,
  purchaseOrderEdit: '/erp/purchase/purchase-order' + CRUDPathSegmentEn.EDIT,

  // GRPOR - Yêu cầu nhập kho
  grpor: '/erp/purchase/grpor',
  grporDetail: '/erp/purchase/grpor' + CRUDPathSegmentEn.DETAIL,
  grporAdd: '/erp/purchase/grpor' + CRUDPathSegmentEn.ADD,
  grporEdit: '/erp/purchase/grpor' + CRUDPathSegmentEn.EDIT,

  // QC Result
  qrResult: '/erp/purchase/qc-result',
  qrResultDetail: '/erp/purchase/qc-result' + CRUDPathSegmentEn.DETAIL,
  qrResultAdd: '/erp/purchase/qc-result' + CRUDPathSegmentEn.ADD,
  qrResultEdit: '/erp/purchase/qc-result' + CRUDPathSegmentEn.EDIT,

  // Hạch toán
  purchaseAccounting: '/erp/purchase/accounting',
  purchaseAccountingDetail: '/erp/purchase/accounting' + CRUDPathSegmentEn.DETAIL,
  purchaseAccountingAdd: '/erp/purchase/accounting' + CRUDPathSegmentEn.ADD,
  purchaseAccountingEdit: '/erp/purchase/accounting' + CRUDPathSegmentEn.EDIT,

  // AP Invoice
  apInvoice: '/erp/purchase/apInvoice',
  apInvoiceDetail: '/erp/purchase/apInvoice' + CRUDPathSegmentEn.DETAIL,
  apInvoiceAdd: '/erp/purchase/apInvoice' + CRUDPathSegmentEn.ADD,
  apInvoiceEdit: '/erp/purchase/apInvoice' + CRUDPathSegmentEn.EDIT,

  // Qualified
  qualified: '/erp/purchase/qualified',
  qualifiedDetail: '/erp/purchase/qualified' + CRUDPathSegmentEn.DETAIL,
  qualifiedAdd: '/erp/purchase/qualified' + CRUDPathSegmentEn.ADD,
  qualifiedEdit: '/erp/purchase/qualified' + CRUDPathSegmentEn.EDIT,

  // Trade payment method - Phương thức thanh toán quốc tế
  tradePaymentMethod: '/erp/purchase/trade-payment-method',
  tradePaymentMethodDetail: '/erp/purchase/trade-payment-method' + CRUDPathSegmentEn.DETAIL,
  tradePaymentMethodAdd: '/erp/purchase/trade-payment-method' + CRUDPathSegmentEn.ADD,
  tradePaymentMethodEdit: '/erp/purchase/trade-payment-method' + CRUDPathSegmentEn.EDIT,

  // Shipping Stage - Chặng vận chuyển
  shippingStage: '/erp/purchase/shipping-stage',
  shippingStageDetail: '/erp/purchase/shipping-stage' + CRUDPathSegmentEn.DETAIL,
  shippingStageAdd: '/erp/purchase/shipping-stage' + CRUDPathSegmentEn.ADD,
  shippingStageEdit: '/erp/purchase/shipping-stage' + CRUDPathSegmentEn.EDIT,

  // Receive plan
  receivePlan: '/erp/purchase/receive-plan',
  // Order history
  orderHistory: '/erp/purchase/orders-history',
  // Debt group
  debtGroup: '/erp/purchase/debt-group',
  // Debt
  debt: '/erp/purchase/debt',
  // SetOfDocument - Bộ chứng từ
  setOfDocument: '/erp/purchase/set-of-documents',
  // DocumentType - Loại chứng từ
  documentType: '/erp/purchase/document-type',
  // RefKey
  refKey: '/erp/purchase/ref-key'
};

export default purchasePath;
